import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import Textfield from "@atlaskit/textfield";
import { ErrorMessage } from "@atlaskit/form";
import { Box } from "@atlaskit/primitives";
import { Cron } from "react-js-cron";
import "react-js-cron/dist/styles.css";
import {
  selectFlow,
  setEditorSaved,
} from "../../../../redux/actions/integrationActions";
import ServerTime from "./ServerTime";
import { Label } from "@atlaskit/form";
import { ConfigProvider } from "antd";

const ScheduledTrigger = () => {
  const [value, setValue] = useState("");
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationError, setValidationError] = useState("");
  const dispatch = useDispatch();

  const flow = useSelector((state) => state.integration.flow);

  useEffect(() => {
    if (flow.trigger) {
      setValue(flow.trigger.value || "");
    }
  }, [flow]);

  const updateRedux = useCallback(
    (_value) => {
      const updatedFlow = {
        ...flow,
        trigger: { ...flow.trigger, value: _value },
      };
      dispatch(selectFlow(updatedFlow));
      dispatch(setEditorSaved(false));
    },
    [dispatch, flow]
  );

  const changeValue = (e) => {
    setValue(e.target.value);
    updateRedux(e.target.value);
  };

  const setValueFromEditor = (_value) => {
    if (flow.trigger?.value !== _value) {
      setValue(_value);
      updateRedux(_value);
    }
  };

  const displayError = (err) => {
    if (err) {
      setShowValidationError(true);
      setValidationError(err.description);
    } else {
      setShowValidationError(false);
      setValidationError("");
    }
  };

  return (
    <div className="ihub-edit-trigger">
      <p>
        Choose when and how often you want this 'Flow' to happen using a 'cron'
        schedule. Our internal scheduler checks for tasks every 60 minutes. This
        means if you set a cron job for a specific time, it will run within 60
        minutes of that time, not exactly at the minute you set.
      </p>
      <Label>Enter Unix formatted cron</Label>
      <Textfield
        name="aws-cron"
        value={value}
        isCompact
        onChange={changeValue}
      />
      {showValidationError && (
        <ErrorMessage>
          <Box as="span">{validationError}</Box>
        </ErrorMessage>
      )}
      <ConfigProvider theme={{ algorithm: "" }}>
        <Cron
          value={value}
          setValue={setValueFromEditor}
          onError={displayError}
          className="cron-selector"
        />
      </ConfigProvider>
      Cron is running on UTC time, current date time is <ServerTime />
    </div>
  );
};

export default ScheduledTrigger;
